import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constant } from '../common/constant';
import { Observable } from 'rxjs';
import { BookedGuestRegisterModel } from '../models/bookedGuest.model';

@Injectable()
export class GuestService {

    constructor(private readonly http: HttpClient) {
    }

    getVisitorByQRCode(details) {
        const url = Constant.REST_URL + Constant.GUEST + Constant.GET_VISITOR_BY_QR_CODE;
        return this.http.post(url, details);
    }

    getAllGuestList(params, searchBy, accountId) {
        const url = Constant.REST_URL + Constant.GUEST + Constant.GET_ALL_GUEST
        + '?page='
        + (params.currentPage - 1 ) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + searchBy +
        '&accountId=' + accountId;
        return this.http.get(url);
    }

    getAllCommercialGuestList(params, searchBy, accountId) {
        const url = Constant.REST_URL + Constant.GUEST + Constant.GET_ALL_COMMERCIAL_GUEST
        + '?page='
        + (params.currentPage - 1 ) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + searchBy +
        '&accountId=' + accountId;
        return this.http.get(url);
    }

    getAllBookedGuestList(params, searchBy, accountId , type,userMasterId) {
        const url = Constant.REST_URL + Constant.GUEST + Constant.GET_ALL_BOOKED_GUEST
        + '?page='
        + (params.currentPage - 1 ) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + searchBy +
        '&accountId=' + accountId + '&type=' + type+ '&userMasterId=' + userMasterId;
        return this.http.get(url);
    }

    getAllBookedCommercialGuestList(params, searchBy, accountId, type, userMasterId) {
        const url = Constant.REST_URL + Constant.GUEST + Constant.GET_ALL_COMMERCIAL_BOOKED_GUEST
        + '?page='
        + (params.currentPage - 1 ) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + searchBy +
        '&accountId=' + accountId + '&type=' + type + '&userMasterId=' + userMasterId;
        return this.http.get(url);
    }

    getGuestImage(id , imageType) {
        const url = Constant.REST_URL + Constant.GUEST + Constant.GET_BASE64_BY_IMAGE_NAME + '?studentId=' + id
        + '&type=' + imageType;
        return this.http.get(url);
    }

    getGuestDataById(guestId) {
        const url = Constant.REST_URL + Constant.GUEST + Constant.GET_GUEST_BY_ID
        + '?guestId=' + guestId;
        return this.http.get(url);
    }

    checkInGuest(details) {
        const url = Constant.REST_URL + Constant.GUEST + Constant.CHECK_IN_CHECK_OUT;
        return this.http.post(url , details);
    }

    sendCheckInNotification(details) {
        const url = Constant.REST_URL + Constant.NOTIFICATION + Constant.SEND_NOTIFICATION;
        return this.http.post(url , details);
    }

    getRecallGuestById(guestId) {
        const url = Constant.REST_URL + Constant.GUEST + Constant.GET_RECALL_GUEST_BY_ID
        + '?guestId=' + guestId;
        return this.http.get(url);
    }

    registerBookedGuest(details): Observable<BookedGuestRegisterModel> {
        const url = Constant.REST_URL + Constant.GUEST + Constant.REGISTER_GUEST;
        return this.http.post<BookedGuestRegisterModel>(url , details);
    }

    registerCommercialGuest(details): Observable<BookedGuestRegisterModel> {
        const url = Constant.REST_URL + Constant.GUEST + Constant.REGISTER_COMMERCIAL_GUEST;
        return this.http.post<BookedGuestRegisterModel>(url , details);
    }

    registerBookedGuestByEmployee(details): Observable<BookedGuestRegisterModel> {
        const url = Constant.REST_URL + Constant.GUEST + Constant.REGISTER_GUEST;
        return this.http.post<BookedGuestRegisterModel>(url , details);
    }

    getAllBookedGuestListByResidentId(params, searchBy, accountId , residentId , type) {
        const url = Constant.REST_URL + Constant.GUEST + Constant.GET_ALL_RESIDENT_GUEST
        + '?page='
        + (params.currentPage - 1 ) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + searchBy +
        '&accountId=' + accountId + '&residentId=' + residentId + '&type=' + type;
        return this.http.get(url);
    }

    getAllCUrrentGuest(params, searchBy, accountId , type ,userMasterId) {
        const url = Constant.REST_URL + Constant.GUEST + Constant.GET_GUEST_CHECK_IN_CHECK_OUT
        + '?page='
        + (params.currentPage - 1 ) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + searchBy +
        '&accountId=' + accountId + '&type=' + type+ '&userMasterId=' + userMasterId;
        return this.http.get(url);
    }

    getAllRecurringGuestList(params, searchBy, accountId) {
        const url = Constant.REST_URL + Constant.GUEST + Constant.GET_ALL_RECURRENT_GUEST
        + '?page='
        + (params.currentPage - 1 ) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + searchBy +
        '&accountId=' + accountId;
        return this.http.get(url);
    }

    getAllCommercialRecurringGuestList(params, searchBy, accountId) {
        const url = Constant.REST_URL + Constant.GUEST + Constant.GET_ALL_RECURRENT_GUEST
        + '?page='
        + (params.currentPage - 1 ) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + searchBy +
        '&accountId=' + accountId;
        return this.http.get(url);
    }

    getAllTrespasserGuestList(params, searchBy, accountId) {
        const url = Constant.REST_URL + Constant.GUEST + Constant.GET_ALL_TRESPASSER_GUEST
        + '?page='
        + (params.currentPage - 1 ) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + searchBy +
        '&accountId=' + accountId;
        return this.http.get(url);
    }

    getAllRejectedVisitorByResidentId(params, searchBy, accountId , residentId , type) {
        const url = Constant.REST_URL + Constant.GUEST + Constant.GET_ALL_REJECTED_VISITOR
        + '?page='
        + (params.currentPage - 1 ) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + searchBy +
        '&accountId=' + accountId + '&residentId=' + residentId + '&type=' + type;
        return this.http.get(url);
    }

    getAllRejectedVisitorForCommercial(params, searchBy, accountId , type) {
        const url = Constant.REST_URL + Constant.GUEST + Constant.GET_ALL_REJECTED_VISITOR
        + '?page='
        + (params.currentPage - 1 ) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + searchBy +
        '&accountId=' + accountId + '&type=' + type;
        return this.http.get(url);
    }

    getDeviceListByGuestId(guestId) {
        const url = Constant.REST_URL + Constant.GUEST + Constant.GET_DEVICE_LIST +
        '?guestId=' + guestId;
        return this.http.get(url);
    }
    getAllCommercialCurrentGuest(params, searchBy, accountId , type,userMasterId) {
        const url = Constant.REST_URL + Constant.GUEST + Constant.GET_COMMERCIAL_GUEST_CHECK_IN_CHECK_OUT
        + '?page='
        + (params.currentPage - 1 ) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + searchBy +
        '&accountId=' + accountId + '&type=' + type + '&userMasterId=' + userMasterId;
        return this.http.get(url);
    }

    sendCommercialCheckInNotification(details) {
        const url = Constant.REST_URL + Constant.NOTIFICATION + Constant.SEND_COMMERCIAL_NOTIFICATION;
        return this.http.post(url , details);
    }

    getVisitorInfoByIdentityNo(details) {
        const url = Constant.REST_URL + Constant.GUEST + Constant.GET_VISITOR_INFO;
        return this.http.post(url , details);
    }

    getAllRecurringGuestDtl(params, searchBy, accountId,guestId) {
        const url = Constant.REST_URL + Constant.GUEST + Constant.GET_RECURRENT_VISITOR_DETAILS
        + '?page='
        + (params.currentPage - 1 ) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + searchBy +
        '&accountId=' + accountId +'&guestId=' + guestId;
        return this.http.get(url);
    }

    regenerateQRCode(guestId) {
        const url = Constant.REST_URL + Constant.GUEST + Constant.REGENERATE_RESIDENT_QRCODE +
         '?guestId=' + guestId;
        return this.http.get(url);
    }

    getHostRecurringGuest(params, searchBy, accountId, type, hostId,) {
        const url = Constant.REST_URL + Constant.GUEST + Constant.GET_HOST_RECURRENT_GUEST
        + '?page='
        + (params.currentPage - 1 ) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + searchBy +
        '&accountId=' + accountId +'&type=' + type +'&hostId=' + hostId;
        return this.http.get(url);
    }

    generateVisitorQRCode(details) {
        const url = Constant.REST_URL + Constant.GUEST + Constant.GENERATE_VISITOR_QRCODE;
        return this.http.post(url , details);
    }

    sendQRInvitation(details) {
        const url = Constant.REST_URL + Constant.GUEST + Constant.SEND_VISITOR_QR_INVITATION;
        return this.http.post(url , details);
    }

    downloadGuestTemplate() {
        const url = Constant.REST_URL + Constant.GUEST + Constant.IMPORT_GUEST_TEMPLATE;
        return this.http.get(url, { responseType: 'blob' });
    }

    importGuests(accountId, formData) {
        const url = Constant.REST_URL + Constant.GUEST + Constant.IMPORT_GUEST + '?accountId=' + accountId;
        return this.http.post(url, formData);
    }

}


